/* eslint-disable */
export default function init() {
  if (window.Calendly && window.Calendly.initInlineWidgets) {
    window.Calendly.initInlineWidgets();
    return;
  }
  (function () {
    window.Calendly = {};
  }.call(this),
    (Calendly.domReady = function (e) {
      var t = !1,
        n = function () {
          document.addEventListener
            ? (document.removeEventListener('DOMContentLoaded', i),
              window.removeEventListener('load', i))
            : (document.detachEvent('onreadystatechange', i), window.detachEvent('onload', i));
        },
        i = function () {
          t ||
            (!document.addEventListener &&
              event.type !== 'load' &&
              document.readyState !== 'complete') ||
            ((t = !0), n(), e());
        };
      if (document.readyState === 'complete') e();
      else if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', i), window.addEventListener('load', i);
      } else {
        document.attachEvent('onreadystatechange', i), window.attachEvent('onload', i);
        let o = !1;
        try {
          o = window.frameElement == null && document.documentElement;
        } catch (l) {}
        o &&
          o.doScroll &&
          !(function r() {
            if (!t) {
              try {
                o.doScroll('left');
              } catch (i) {
                return setTimeout(r, 50);
              }
              (t = !0), n(), e();
            }
          })();
      }
    }),
    function () {
      (Calendly.initInlineWidgets = function () {
        return Calendly.domReady(() => Calendly.createInlineWidgets());
      }),
        (Calendly.initBadgeWidget = function (e) {
          return Calendly.domReady(() => Calendly.createBadgeWidget(e));
        }),
        (Calendly.createInlineWidgets = function () {
          let e, t, n, i, o;
          for (
            t = document.querySelectorAll('.calendly-inline-widget'), o = [], n = 0, i = t.length;
            i > n;
            n++
          ) {
            e = t[n];
            if (!e.getAttribute('data-processed')) {
              e.setAttribute('data-processed', 'true');
              new Calendly.Iframe(e, !0, 'Inline');
            }
          }
        }),
        (Calendly.createBadgeWidget = function (e) {
          return (
            this.destroyBadgeWiget(),
            (Calendly.badgeWidget = new Calendly.BadgeWidget({
              color: e.color,
              text: e.text,
              branding: e.branding,
              onClick() {
                return Calendly.showPopupWidget(e.url, 'PopupWidget');
              },
            }))
          );
        }),
        (Calendly.destroyBadgeWiget = function () {
          return Calendly.badgeWidget
            ? (Calendly.badgeWidget.destroy(), delete Calendly.badgeWidget)
            : void 0;
        }),
        (Calendly.showPopupWidget = function (e, t) {
          return (
            t == null && (t = 'PopupText'),
            this.closePopupWidget(),
            (Calendly.popupWidget = new Calendly.PopupWidget(
              e,
              () => delete Calendly.popupWidget,
              t,
            )),
            Calendly.popupWidget.show()
          );
        }),
        (Calendly.closePopupWidget = function () {
          return Calendly.popupWidget ? Calendly.popupWidget.close() : void 0;
        });
    }.call(this),
    function () {
      Calendly.Iframe = (function () {
        function e(e, t, n) {
          (this.parent = e),
            (this.inlineStyles = t != null ? t : !1),
            (this.embedType = n),
            this.build(),
            this.inject();
        }
        return (
          (e.prototype.isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent,
            )),
          (e.prototype.build = function () {
            return (
              (this.node = document.createElement('iframe')),
              (this.node.src = this.getSource()),
              (this.node.width = '100%'),
              (this.node.height = '100%'),
              (this.node.frameBorder = '0')
            );
          }),
          (e.prototype.inject = function () {
            return (
              this.format(),
              this.parent.appendChild(this.buildSpinner()),
              this.parent.appendChild(this.node)
            );
          }),
          (e.prototype.getSource = function () {
            return `${this.getURL()}${this.getDivider()}${this.getParams()}`;
          }),
          (e.prototype.getURL = function () {
            return this.url != null
              ? this.url
              : (this.url = this.parent.getAttribute('data-url').split('#')[0]);
          }),
          (e.prototype.getDivider = function () {
            return this.getURL().indexOf('?') === -1 ? '?' : '&';
          }),
          (e.prototype.getParams = function () {
            return `embed_domain=${this.getDomain()}&embed_type=${this.embedType}`;
          }),
          (e.prototype.getDomain = function () {
            return encodeURIComponent(document.location.origin);
          }),
          (e.prototype.format = function () {
            return this.isMobile ? this.formatMobile() : this.formatDesktop();
          }),
          (e.prototype.formatDesktop = function () {
            return this.inlineStyles
              ? this.parent.setAttribute(
                  'style',
                  `position: relative;${this.parent.getAttribute('style')}`,
                )
              : void 0;
          }),
          (e.prototype.formatMobile = function () {
            return this.inlineStyles
              ? this.parent.setAttribute(
                  'style',
                  `position: relative;overflow-y:auto;-webkit-overflow-scrolling:touch;${this.parent.getAttribute(
                    'style',
                  )}`,
                )
              : (this.parent.className += ' mobile');
          }),
          (e.prototype.buildSpinner = function () {
            let e;
            return (
              (e = document.createElement('div')),
              (e.className = 'spinner'),
              e.appendChild(this.buildBounce(1)),
              e.appendChild(this.buildBounce(2)),
              e.appendChild(this.buildBounce(3)),
              e
            );
          }),
          (e.prototype.buildBounce = function (e) {
            let t;
            return (t = document.createElement('div')), (t.className = `bounce${e}`), t;
          }),
          e
        );
      })();
    }.call(this),
    function () {
      const e = function (e, t) {
        return function () {
          return e.apply(t, arguments);
        };
      };
      Calendly.PopupWidget = (function () {
        function t(t, n, i) {
          (this.url = t),
            (this.onClose = n),
            (this.embedType = i),
            (this.close = e(this.close, this)),
            (this.pageRoot = document.getElementsByTagName('html')[0]);
        }
        return (
          (t.prototype.show = function () {
            return this.buildOverlay(), this.insertOverlay(), this.lockPageScroll();
          }),
          (t.prototype.close = function () {
            return this.destroyOverlay(), this.onClose(), this.unlockPageScroll();
          }),
          (t.prototype.buildOverlay = function () {
            return (
              (this.overlay = document.createElement('div')),
              (this.overlay.className = 'calendly-overlay'),
              this.overlay.appendChild(this.buildCloseOverlay()),
              this.overlay.appendChild(this.buildPopup())
            );
          }),
          (t.prototype.insertOverlay = function () {
            return document.body.insertBefore(this.overlay, document.body.firstChild);
          }),
          (t.prototype.buildCloseOverlay = function () {
            let e;
            return (
              (e = document.createElement('div')),
              (e.className = 'calendly-close-overlay'),
              (e.onclick = this.close),
              e
            );
          }),
          (t.prototype.buildPopup = function () {
            let e;
            return (
              (e = document.createElement('div')),
              (e.className = 'calendly-popup'),
              e.appendChild(this.buildPopupContent()),
              e.appendChild(this.buildCloseButton()),
              e
            );
          }),
          (t.prototype.buildPopupContent = function () {
            let e;
            return (
              (e = document.createElement('div')),
              (e.className = 'calendly-popup-content'),
              e.setAttribute('data-url', this.url),
              new Calendly.Iframe(e, !1, this.embedType),
              e
            );
          }),
          (t.prototype.buildCloseButton = function () {
            let e;
            return (
              (e = document.createElement('div')),
              (e.className = 'calendly-popup-close'),
              (e.onclick = this.close),
              e
            );
          }),
          (t.prototype.destroyOverlay = function () {
            return this.overlay.parentNode.removeChild(this.overlay);
          }),
          (t.prototype.lockPageScroll = function () {
            return (this.pageRoot.className += ' calendly-page-scroll-locked');
          }),
          (t.prototype.unlockPageScroll = function () {
            return (this.pageRoot.className = this.pageRoot.className.replace(
              ' calendly-page-scroll-locked',
              '',
            ));
          }),
          t
        );
      })();
    }.call(this),
    function () {
      Calendly.BadgeWidget = (function () {
        function e(e) {
          (this.options = e), this.buildWidget(), this.insertWidget();
        }
        return (
          (e.prototype.destroy = function () {
            return this.widget.parentNode.removeChild(this.widget);
          }),
          (e.prototype.buildWidget = function () {
            return (
              (this.widget = document.createElement('div')),
              (this.widget.className = 'calendly-badge-widget'),
              this.widget.appendChild(this.buildContent())
            );
          }),
          (e.prototype.insertWidget = function () {
            return document.body.insertBefore(this.widget, document.body.firstChild);
          }),
          (e.prototype.buildContent = function () {
            let e;
            return (
              (e = document.createElement('div')),
              (e.className = 'calendly-badge-content'),
              this.options.color === '#ffffff' && (e.className += ' white'),
              (e.onclick = this.options.onClick),
              (e.innerHTML = this.options.text),
              (e.style.background = this.options.color),
              this.options.branding && e.appendChild(this.buildBranding()),
              e
            );
          }),
          (e.prototype.buildBranding = function () {
            let e;
            return (e = document.createElement('span')), (e.innerHTML = 'powered by Calendly'), e;
          }),
          e
        );
      })();
    }.call(this),
    Calendly.initInlineWidgets());
}
